import React, { useState } from 'react';
import { ReactComponent as BannerIcon } from 'icons/banner-filled-icon.svg';
import { useAppContext } from 'components/Context/AppContext';
import { TableWrapper, Table, PaginationTable } from 'components/Global';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { deleteBanner, getAllBanner } from 'features/banner/actions';
import { trackEvent } from 'utils/analytics';
import ButtonAdd from 'components/Global/ButtonAdd';
import EmptyState from 'components/Global/EmptyState';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import { format, parseISO } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { formatGoogleDriveUrl } from 'utils/helpers';
import { getConfig } from 'config/runtime';

const imageUrl = getConfig('REACT_APP_IMAGES');

const column = [
  { header: 'No.', value: 'no' },
  { header: 'Banner', value: 'banner_image' },
  { header: 'Tanggal Mulai', value: 'start_date' },
  { header: 'Tanggal Berakhir', value: 'end_date' },
  { header: 'Promo', value: 'promo' },
];

const BannerComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { setShowConfirmation, showToast } = useAppContext();
  const { data: banners, isLoading } = useSelector((state) => state.banner);

  const [currentPage, setCurrentPage] = useState(1);

  const handleDelete = (e) => {
    const imageId = e.target.parentElement.parentElement.dataset['key'];
    if (!imageId) return;

    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus data?',
      show: true,
      onClick: async () => {
        try {
          trackEvent('banner_deleted', { banner_id: imageId, source: 'banner_list' });
          await dispatch(deleteBanner(imageId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Menghapus data' });
          dispatch(getAllBanner());
        } catch (error) {
          showToast({ type: 'error', message: 'Gagal Menghapus data' });
        }
      },
    });
  };

  const handleEdit = (e) => {
    const dataId = e.target.parentElement.parentElement.dataset['key'];
    navigate(`/banner/edit/${dataId}`);
  };

  useEffect(() => {
    dispatch(getAllBanner());
  }, []);

  const tableData = banners?.map((item) => ({
    ...item,
    banner_image: item.image ? imageUrl + item.image : formatGoogleDriveUrl(item.link),
    start_date: item.start_date === '2000-01-01T00:00:00Z' ? '-' : format(parseISO(item.start_date), 'dd/MM/yyyy'),
    end_date: item.end_date === '3000-01-01T00:00:00Z' ? '-' : format(parseISO(item.end_date), 'dd/MM/yyyy'),
  }));

  const location = useLocation();
  const isModalOpen = location.pathname.includes('/add') || location.pathname.includes('/edit');

  return (
    <div className="banner">
      <ButtonAdd onClick={() => navigate('/banner/edit')} label="Tambah Banner" />

      <TableWrapper title="Banner" icon={<BannerIcon fill="#009EF7" width="25px" height="25px" />}>
        {isLoading ? (
          <LoadingSpinner />
        ) : banners?.length ? (
          <>
            <Table
              column={column}
              data={tableData}
              actionBtn
              onDel={handleDelete}
              onEdit={handleEdit}
              currentPage={currentPage}
            />
            <PaginationTable
              currentPage={currentPage}
              onPageChange={(newPage) => setCurrentPage(newPage)}
              // totalCount={data?.pagination?.total}
            />
          </>
        ) : (
          <EmptyState />
        )}
      </TableWrapper>

      {isModalOpen && (
        <div className="modal-overlay">
          <Outlet />
        </div>
      )}
    </div>
  );
};

export default BannerComponent;
